import React from 'react';
import { Pie } from 'react-chartjs-2';

export default ({ eventStatusBreakDown }) => {
    let eventCreations = eventStatusBreakDown.eventCreations;
    let eventReview = eventStatusBreakDown.eventReview;
    let afterActionIncomplete = eventStatusBreakDown.afterActionIncomplete;
    let afterActionReview = eventStatusBreakDown.afterActionReview;
    let afterActionPending = eventStatusBreakDown.afterActionPending;
    let eventAAClosed = eventStatusBreakDown.eventAAClosed;

    const totalCount =
        eventCreations +
        eventReview +
        afterActionIncomplete +
        afterActionReview +
        afterActionPending +
        eventAAClosed;
    let feedtotal =
        eventCreations +
        eventReview +
        afterActionIncomplete +
        afterActionReview +
        afterActionPending +
        eventAAClosed;
    feedtotal = feedtotal > 0 ? feedtotal : 1; // avoid divide by zero

    let mobileCopy = '';
    let mobileNum = 'Loading';
    mobileNum =
        Math.round(
            (Math.max(
                eventCreations,
                eventReview,
                afterActionIncomplete,
                afterActionReview,
                afterActionPending,
                eventAAClosed
            ) /
                feedtotal) *
                100
        ) + '%';

    let feedlist = [
        eventCreations,
        eventReview,
        afterActionIncomplete,
        afterActionReview,
        afterActionPending,
        eventAAClosed
    ];
    switch (feedlist.indexOf(Math.max.apply(null, feedlist))) {
        case 0:
            mobileCopy = 'Event Creation';
            break;
        case 1:
            mobileCopy = 'Event Review';
            break;
        case 2:
            mobileCopy = 'After Action Incomplete';
            break;
        case 3:
            mobileCopy = 'After Action Review';
            break;
        case 4:
            mobileCopy = 'After Action Pending';
            break;
        case 5:
            mobileCopy = 'Event/AA Closed';
            break;
        default:
            mobileCopy = '';
    }

    return (
        <div>
            {totalCount === 0 ? (
                <div className="dashboard__no-events">
                    <div className="dashboard-title dashboard-title--no-events">
                        No Events To Display
                    </div>
                </div>
            ) : (
                <div>
                    <div className="dashboard-pie">
                        <Pie
                            data={{
                                title: 'Event Status Breakdown',
                                mobileDescription: 'Events in review',
                                labels: [
                                    'Event Creation',
                                    'Event Review',
                                    'After Action Incomplete',
                                    'After Action Review',
                                    'After Action Pending',
                                    'Event/AA Closed'
                                ],
                                datasets: [
                                    {
                                        data: [
                                            eventCreations,
                                            eventReview,
                                            afterActionIncomplete,
                                            afterActionReview,
                                            afterActionPending,
                                            eventAAClosed
                                        ],
                                        backgroundColor: [
                                            '#C0C2CA',
                                            '#013142',
                                            '#B01E28',
                                            '#5C6373',
                                            '#000000',
                                            '#90132A'
                                        ]
                                    }
                                ]
                            }}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                legend: {
                                    display: false
                                }
                            }}
                        />
                    </div>
                    <div className="dashboard-title-desktop">
                        Event Status Breakdown
                    </div>
                    <div className="dashboard-title-mobile dashboard-title-mobile__pie">
                        <span className="dashboard-title-value">
                            {mobileNum}
                        </span>
                        {mobileCopy}
                    </div>
                    <div className="dashboard__legend legend">
                        <div className="legend-filter legend-filter--creation">
                            <span className="legend-title">
                                <span>Event Creation</span>
                            </span>
                        </div>
                        <div className="legend-filter legend-filter--review">
                            <span className="legend-title">
                                <span>Event Review</span>
                            </span>
                        </div>
                        <div className="legend-filter legend-filter--aaIncomplete">
                            <span className="legend-title">
                                <span>After Action Incomplete</span>
                            </span>
                        </div>
                        <div className="legend-filter legend-filter--aaReview">
                            <span className="legend-title">
                                <span>After Action Review</span>
                            </span>
                        </div>
                        <div className="legend-filter legend-filter--aaPending">
                            <span className="legend-title">
                                <span>After Action Pending</span>
                            </span>
                        </div>
                        <div className="legend-filter legend-filter--eventAAClosed">
                            <span className="legend-title">
                                <span>Event/AA Closed</span>
                            </span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/dashboard/event-status.js